// extracted by mini-css-extract-plugin
export default {"CardInCard":"CardInCard_CardInCard__VYP7Q","CardInCardTitle":"CardInCard_CardInCardTitle__iG3so","CardInCardContent":"CardInCard_CardInCardContent__z4sOR"};